import { render } from "./InfoSection.vue?vue&type=template&id=bbb9fa3c&scoped=true"
import script from "./InfoSection.vue?vue&type=script&lang=js"
export * from "./InfoSection.vue?vue&type=script&lang=js"

import "./InfoSection.vue?vue&type=style&index=0&id=bbb9fa3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbb9fa3c"]])

export default __exports__